import envValues from '../enviornment';

export const SERVER_URL = `${envValues.REACT_APP_API_ENDPOINT}/auth`;
export const SERVER_BASE_URL = envValues.REACT_APP_API_ENDPOINT;
export const APP_API_URL = `${envValues.REACT_APP_APP_API_ENDPOINT}/auth`;
export const APP_API_BASE_URL = envValues.REACT_APP_APP_API_ENDPOINT;
export const ERROR_MESSAGE = 'Api Fetch Error!';
export const ENCRYPT_SECERET_KEY = 'armia-secret-key@123';
export const REACT_APP_API_POST_USER = `${envValues.REACT_APP_API_ENDPOINT}/user`;
export const REACT_APP_API_FETCH_USER = `${envValues.REACT_APP_API_ENDPOINT}/user?`;
export const REACT_APP_API_FETCH_EMPLOYEE = `${envValues.REACT_APP_API_ENDPOINT}/employee?active=true&`;
export const REACT_APP_API_FETCH_ROLE = `${envValues.REACT_APP_API_ENDPOINT}/roles?active=true&`;
export const REACT_APP_API_SKILLS = `${envValues.REACT_APP_API_ENDPOINT}/dummy/selectdata`;
export const REACT_APP_API_ROLES_DROPDOWN = `${envValues.REACT_APP_API_ENDPOINT}/roles/select`;
export const REACT_APP_API_FETCH_MOVIES = `${envValues.REACT_APP_API_ENDPOINT}/movies?active=true&`;
export const REACT_APP_API_FETCH_NOTIFICATIONS = `${envValues.REACT_APP_API_ENDPOINT}/notifications?`;
export const REACT_APP_API_FETCH_NOTIFICATIONS_ALL = `${envValues.REACT_APP_API_ENDPOINT}/notifications/all?`;
export const REACT_APP_API_FETCH_ITEMS = `${envValues.REACT_APP_API_ENDPOINT}/items?`;
export const REACT_APP_API_FETCH_EVENTS = `${envValues.REACT_APP_API_ENDPOINT}/calendar`;

export const REACT_APP_API_FETCH_COLLAB_HISTORY = `${envValues.REACT_APP_API_ENDPOINT}/user/collab-history`;
export const REACT_APP_API_FETCH_CONTENT_POSTS = `${envValues.REACT_APP_API_ENDPOINT}/user/content-posts`;
export const REACT_APP_API_FETCH_CONTENT_REPORTS = `${envValues.REACT_APP_API_ENDPOINT}/report/content-report?`;
export const REACT_APP_API_FETCH_USER_REPORTS = `${envValues.REACT_APP_API_ENDPOINT}/report/user-report?`;
export const REACT_APP_API_FETCH_COLLAB_REQUESTS = `${envValues.REACT_APP_API_ENDPOINT}/collab-request?`;
export const REACT_APP_API_FETCH_COLLAB_REQUESTS_SUMMARY = `${envValues.REACT_APP_API_ENDPOINT}/collab-request/summary`;
export const REACT_APP_API_FETCH_COLLAB_REQUEST_DETAILS = `${envValues.REACT_APP_API_ENDPOINT}/collab-request/`;
export const REACT_APP_API_FETCH_APPUPDATES = `${envValues.REACT_APP_API_ENDPOINT}/appupdate?`;

export const REACT_APP_API_FETCH_FLAGGED_REQUESTS = `${envValues.REACT_APP_API_ENDPOINT}/collab-request/flagged?`;
export const REACT_APP_API_FETCH_FLAGGED_REQUEST_DETAILS = `${envValues.REACT_APP_API_ENDPOINT}/collab-request/flagged/`;
export const REACT_APP_API_FETCH_CONTENT_REPORT_DETAILS = `${envValues.REACT_APP_API_ENDPOINT}/report/content-report/`;

export const REACT_APP_API_FETCH_USER_REPORT_DETAILS = `${envValues.REACT_APP_API_ENDPOINT}/report/user-report/`;
export const REACT_APP_API_DELETE_MESSAGE_THREAD = `${envValues.REACT_APP_API_ENDPOINT}/collab-request/remove-message-thread/`;

export const REACT_APP_API_FETCH_FEEDBACKS = `${envValues.REACT_APP_API_ENDPOINT}/feedback?`;
export const REACT_APP_API_FETCH_FEEDBACK_DETAILS = `${envValues.REACT_APP_API_ENDPOINT}/feedback/`;
export const REACT_APP_API_UPDATE_FEEDBACK_STATUS = `${envValues.REACT_APP_API_ENDPOINT}/feedback/`;
export const REACT_APP_API_DELETE_FEEDBACK = `${envValues.REACT_APP_API_ENDPOINT}/feedback/`;

export const REACT_APP_API_GET_APP_PREFERENCES = `${envValues.REACT_APP_API_ENDPOINT}/app-preferences`;
export const REACT_APP_API_UPDATE_APP_PREFERENCES = `${envValues.REACT_APP_API_ENDPOINT}/app-preferences`;
